/**
 * 默认增值服务类型
 */
export const RECHARGE_A_YEAR = 'AYear';
export type RECHARGE_A_YEAR = typeof RECHARGE_A_YEAR;
export const RECHARGE_A_QUARTER = 'AQuarter';
export type RECHARGE_A_QUARTER = typeof RECHARGE_A_QUARTER;
export const RECHARGE_A_MONTH = 'AMonth';
export type RECHARGE_A_MONTH = typeof RECHARGE_A_MONTH;
export const RECHARGE_SEVEN_DAY = 'SevenDay';
export type RECHARGE_SEVEN_DAY = typeof RECHARGE_SEVEN_DAY;
export type RECHARGE_TYPE = RECHARGE_A_YEAR | RECHARGE_A_QUARTER | RECHARGE_A_MONTH | RECHARGE_SEVEN_DAY;

/**
 * 增值服务接口
 * @export
 * @interface IRechargeInfo
 */
export interface IRechargeInfo {
  value: number;
  name: string;
  key: string;
  type: RECHARGE_TYPE;
}

export interface IRechargeOption {
  package: number;
  transl_key: string;
}



// WEBPACK FOOTER //
// ./src/entity/RechargeEntity.ts